import {
    ApiClientAxios,
    apiFactoryConfig
} from "@repo/api";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

export const useResolveInvestorProfileQuestionnaireMutation = (
    options?: Partial<UseMutationOptions<ApiClientAxios.QuestionnaireEvaluateResult, Error, ApiClientAxios.QuestionnaireEvaluateRequestAnswers>>,
) => {
    const api = ApiClientAxios.InvestorProfileApiFactory(...apiFactoryConfig);

    return useMutation<ApiClientAxios.QuestionnaireEvaluateResult, Error, ApiClientAxios.QuestionnaireEvaluateRequestAnswers>({
        mutationFn: async (data: ApiClientAxios.QuestionnaireEvaluateRequestAnswers) =>
            (await api.postInvestorProfileApimPost(data)).data,
        ...options,
    });
};
